export const KpiNotificationsTableColumns = [
    {
        id: 'title',
        title: 'REPORT_DIALOG.EDIT_KPI_NOTIFICATIONS.TABLE.HEADER.KPI.NAME',
        minWidth: 200,
    },
    {
        id: 'lowerLimit',
        title: 'REPORT_DIALOG.EDIT_KPI_NOTIFICATIONS.TABLE.HEADER.LOWER.LIMIT',
        maxWidth: 150,
    },
];
